import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import faqbg from "../assets/images/faq-bg.webp";

const FAQSection = ({ faqData }) => {
  const [expanded, setExpanded] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (panel) => () => {
    setExpanded(expanded === panel ? null : panel);
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${faqbg})`,
        borderRadius: 5,
        pb: 3,
        mb: 5,
        maxWidth: "100%",
      }}
    >
      <Container maxWidth="lg" sx={{ p: { xs: 2, md: 5 } }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ xs: "center" }}
          justifyContent="space-between"
          sx={{ maxWidth: "100%" }}
        >
          <Box
            mb={{ xs: 3, md: 5 }}
            sx={{
              width: { xs: "100%", md: "50%" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "#000",
                fontSize: { xs: "2rem", md: "3rem" },
                mb: 0,
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
              }}
            >
              Frequently
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: "#000",
                fontSize: { xs: "2rem", md: "3rem" },
                mb: 0,
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
              }}
            >
              Asked <span style={{ color: "#0265fe" }}>Questions</span>
            </Typography>
          </Box>

          <Box
            sx={{
              maxWidth: { xs: "100%", md: 600 },
              mx: "auto",
              p: { xs: 0, md: 2 },
              width: { xs: "100%", md: "auto" },
            }}
          >
            {faqData.map((faq, index) => (
              <Accordion
                key={faq.id}
                expanded={expanded === faq.id}
                onChange={handleChange(faq.id)}
                sx={{
                  borderBottom:
                    index === faqData.length - 1 ? "none" : "1px solid #f0f0f0",
                  boxShadow: "none",
                  "&:before": {
                    display: "none",
                  },
                  "&.MuiAccordion-root": {
                    borderRadius: 0,
                  },
                  mb: { xs: 1, md: 0 },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 24,
                        height: 24,
                        transition: "transform 0.3s ease",
                        transform:
                          expanded === faq.id
                            ? "rotate(45deg)"
                            : "rotate(0deg)",
                      }}
                    >
                      <AddIcon
                        sx={{
                          color: "#0265fe",
                          fontSize: 20,
                          transition: "transform 0.3s ease",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 600,
                        }}
                      />
                    </Box>
                  }
                  sx={{
                    py: { xs: 1.5, md: 2 },
                    px: { xs: 1, md: 2 },
                    mt: { xs: 1, md: 2 },
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow:
                      expanded === faq.id
                        ? "none"
                        : "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
                    minHeight: { xs: 48, md: 64 },
                    "&.MuiAccordionSummary-root": {
                      borderBottom: "none",
                      borderTop: "none",
                    },
                    "& .MuiAccordionSummary-content": {
                      margin: 0,
                    },
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      borderRadius: "12px",
                      color: "#666666",
                      fontFamily: "Inter, sans-serif",
                      fontSize: { xs: "0.9rem", md: "1.125rem" },
                      fontWeight: 500,
                      lineHeight: 1.5,
                      flex: 1,
                      pr: { xs: 1, md: 2 },
                    }}
                  >
                    {faq.question}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    px: 0,
                    pb: { xs: 2, md: 3 },
                    pt: 0,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      color: "#888888",
                      fontSize: { xs: "0.85rem", md: "1rem" },
                      lineHeight: 1.6,
                      ml: { xs: 1, md: 2 },
                    }}
                  >
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default FAQSection;
